<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                服务场景
            </div>
        </div>
        <!-- 盒子 -->
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[0].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[0].title}}</div>
                        <div class="border_content_one">{{images[0].content}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[1].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[1].title}}</div>
                        <div class="border_content_one">{{images[1].content}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[2].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[2].title}}</div>
                        <div class="border_content_one">{{images[2].content}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[3].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[3].title}}</div>
                        <div class="border_content_one">{{images[3].content}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12"  :md="8">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[4].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[4].title}}</div>
                        <div class="border_content_one">{{images[4].content}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12"  :md="8">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[5].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[5].title}}</div>
                        <div class="border_content_one">{{images[5].content}}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
       
        <!-- 后台管理 -->
        <div id="产品特色" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                产品特色
            </div>
        </div>
        <div class="product_spec_parent">
            <img :src="hzImg[1].img" style="width: 100%;"/>
        </div>
        <!-- 产品特点-->
        <div id="核心功能" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                核心功能
            </div>
        </div>
        
        <div class="product_spec_parent">
            <img :src="hzImg[0].img" style="width: 100%;"/>
        </div>
        <!-- 免费试用-->
        <div id="免费试用" class="cooperation head-label">
            <div style="text-align: center;" class="font_size_24">
                免费试用
            </div>
        </div>
        <div class="container">
    <el-form class = "form" ref="elForm" :model="formData" :rules="rules" size="medium">
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="formData.companyName" placeholder="请输入公司名称" show-word-limit clearable
          :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name" placeholder="请输入姓名" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formData.phone" placeholder="请输入手机号" :maxlength="11" clearable
          :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
        </div>
        <!-- 联系我们-->
        <div id="联系我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                联系我们
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p>
                <p class="about_me_p">{{company[4]}}</p>
            </div>
        </div>

    </div>
</template>

<script>
import {saveInfo} from '@/api/sc';

    export default {
        name: 'Index',
        data() {
            return {
                formData: {
                    companyName: '',
                    name: undefined,
                    phone: undefined,
                    submit: undefined,
                },
      rules: {
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
          message: '手机号格式错误',
          trigger: 'blur'
        }],
      },
                sliders: [],
                hzImg: [
                    {
                        img: require('../../static/other/index_5_img.png')
                    },
                    {
                        img: require('../../static/other/Dingtalk_20240124164945.jpg')
                    }

                ],
                images: [
                    {
                        img: require('../../static/other/6554692.png'),
                        title: "营销",
                        content: "营销丨逾期提醒/催收丨客户关怀回访丨促销活动/APP下载邀约"
                    },
                    {
                        img: require('../../static/other/6554694.png'),
                        title: "运营商",
                        content: "手机卡营销丨新业务促销丨优惠活动邀约丨客户关怀回访"
                    },
                    {
                        img: require('../../static/other/6554689.png'),
                        title: "地产",
                        content: "地产营销丨装修装饰营销丨会议邀约丨客户关怀回访"
                    }, {
                        img: require('../../static/other/6554690.png'),
                        title: "互联网",
                        content: "前端获客丨APP下载邀约丨活动通知邀约丨客户关怀回访"
                    },
                    {
                        img: require('../../static/other/6554693.png'),
                        title: "医疗",
                        content: "医疗美容营销丨促销活动邀约丨服务确认丨通知回访"
                    },
                    {
                        img: require('../../static/other/6554691.png'),
                        title: "教育",
                        content: "课程推广丨试听邀约丨活动邀约丨客户关怀回访"
                    }
                ],
                products: [
                    {
                        img: [
                           
                        ],
                        title: "手机端商品展示，强大的商品规格设计",
                        content: [
                            "商品热销分类显，分类导航显示所有分类", 
                            "热销商品优先排序 商城首页轮播自定义",
                            "单品、多规格、加料、属性、多价格展示",
                            "商品分类列表支持虚拟列表，滚动众享丝滑",
                            "无需注册会员，商品在线购买支付"
                        ]
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/product_info.jpg')],
                        title: "小程序+PC管理平台",
                        content: ["录音质检", "智能外呼",
                            "客户/公海",
                            "员工呼叫统计", "黑名单检测",
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "一键建铺",
                            contents: ["注册一键创建店铺", "开启您的专属店铺"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "店铺装扮",
                            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"]
                        },
                        {
                            img: require('../../static/other/数据分析.png'),
                            title: "营销分析",
                            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "助力零售",
                            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"]
                        }
                    ]
                },
                company: [
                    "关于我们：河南陆寻通讯设备有限公司是一家专注互联网通信平台公司，提供云呼叫中心、回拨、云通信等产品。平台提供丰富API/SDK无缝集成到业务应用中，全方位，一站式解决通信的应用。",
                    "我们是一家以通讯为核心，专注于呼叫中心和融合通信产品研发、销售的科技公司。 数年的沉淀让我们拥有容器虚拟，独立环境开发等技术，拥有实力雄厚的公司客户。如今，我们仍兢兢业业的坚持以技术创新为原动力，融合客户需求为本质，帮助客户解决问题，提供更强有力的技术支持。致力于产品的第三方开发接口、呼叫中心集群管理与云计算等技术发展！",
                    "核心产品：针对电销团队、客服中心的各种痛点，帮助企业提高电销接通效率，降低运营成本，提升企业与客户的沟通效率，为企业提高用户体验和超预期的使用价值。为沟通创造价值，是创想的企业愿景。一直以来创想通信以服务用户为导向，遵循创新、卓越的产品理念，为用户提供便捷、可靠、稳定的通信服务，让用户享受高效沟通带来的美好体验。",
                    "联系方式: 王经理：17719961340 \xa0 \xa0 白经理：18736094211"
                ],
                carousel_height: '550px',
            }
        },
        methods: {
            submitForm() {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
            saveInfo(JSON.stringify(this.formData));
            this.$refs.elForm.resetFields();
            }   
            });
        }
    },
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/a1.png")
                },
                {
                    img: require("../../static/slider/a2.png")
                }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 550px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .container {
  width: 100%;
  text-align: center;
}
.form {
  margin: 0 auto;
  width: 50%;
}

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: 320px;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>